import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { doc, getDoc } from "firebase/firestore";
import { db } from "../../../firebaseConfig";
import { setShippingServiceState } from "../../../store/shippingServiceSlice";
import {
  Stepper,
  Step,
  StepLabel,
  Button,
  Typography,
  TextField,
  FormControl,
  FormLabel,
  RadioGroup,
  FormControlLabel,
  Radio,
  MenuItem,
  Select,
  Box,
  StepConnector,
  Grid,
  OutlinedInput,
  Stack,
} from "@mui/material";
import ShippingWarehouseStep from "./ShippingWarehouseStep";
import DeliveryPartnerStep from "./DeliveryPartnerStep";
import ShippingCarrierStep from "./ShippingCarrierStep";
import ShippingPriceStep from "./ShippingPriceStep";
import { mapFirestoreToRedux } from "../../../helper/functions";

const steps = [
  { label: "Shipping Warehouse" },
  { label: "Delivery Partner" },
  { label: "Carrier" },
  { label: "Set Shipping Price" },
];

const ShippingStepper = (props) => {
  const { shippingServiceId: propId } = props;
  const params = useParams();
  const shippingServiceId = propId || params.shippingServiceId;
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchShippingService = async () => {
      if (shippingServiceId) {
        setLoading(true);
        try {
          const docRef = doc(db, "shippingServices", shippingServiceId);
          const docSnap = await getDoc(docRef);
          if (docSnap.exists()) {
            const mapped = mapFirestoreToRedux(docSnap.data(), shippingServiceId);
            dispatch(setShippingServiceState(mapped));
          }
        } catch (error) {
          console.error("Error fetching shipping service for edit:", error);
        } finally {
          setLoading(false);
        }
      }
    };
    fetchShippingService();
  }, [shippingServiceId, dispatch]);

  const [activeStep, setActiveStep] = useState(0);

  const handleNext = () => {
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const handleReset = () => {
    setActiveStep(0);
  };

  function getStepContent(step) {
    switch (step) {
      case 0:
        return <ShippingWarehouseStep onBack={handleBack} onNext={handleNext} loading={loading} />;
      case 1:
        return <DeliveryPartnerStep onBack={handleBack} onNext={handleNext} loading={loading} />;
      case 2:
        return <ShippingCarrierStep onBack={handleBack} onNext={handleNext} loading={loading} />;
      case 3:
        return <ShippingPriceStep onBack={handleBack} onNext={handleNext} loading={loading} />;
      default:
        return "Unknown step";
    }
  }

  return (
    <Box
      sx={{
        margin: "0 auto",
        padding: "20px",
        backgroundColor: "white",
      }}
    >
      <Stepper
        activeStep={activeStep}
        alternativeLabel
        sx={{
          width: "50%", // Set the Stepper width to 50%
          margin: "0 auto", // Center the Stepper
          paddingBottom: 5,
        }}
      >
        {steps.map((step) => (
          <Step key={step.label}>
            <StepLabel>
              <span
                style={{ fontSize: "16px", fontWeight: "bold", color: "black" }}
              >
                {step.label}
              </span>
            </StepLabel>
            {step.index > 0 && (
              <StepConnector
                sx={{
                  "& .MuiStepConnector-line": {
                    borderWidth: "1px",
                    borderColor: "#EDEDED",
                  },
                }}
              />
            )}
          </Step>
        ))}
      </Stepper>
      <Box>
        {activeStep === steps.length ? (
          <Box>
            <Typography>All steps completed</Typography>
            <Button onClick={handleReset}>Reset</Button>
          </Box>
        ) : (
          <Box>
            {getStepContent(activeStep)}
          </Box>
        )}
      </Box>
    </Box>
  );
};

export default ShippingStepper;
